import { render, staticRenderFns } from "./AllBays.vue?vue&type=template&id=5c6ffcaa&scoped=true"
import script from "./AllBays.vue?vue&type=script&lang=js"
export * from "./AllBays.vue?vue&type=script&lang=js"
import style0 from "./AllBays.vue?vue&type=style&index=0&id=5c6ffcaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6ffcaa",
  null
  
)

export default component.exports